<script lang="ts" setup>

  type Props = {
    disabled?: boolean
    max?: number
  }

  const props = withDefaults(defineProps<Props>(), {
    disabled: false,
    max: 4,
  })
  const model = defineModel<number>({ required: true })
  function input(value: number): void {
    model.value = value
  }

  function plus(): void {
    const newValue = model.value + 1
    input(newValue)
  }

  function minus(): void {
    const newValue = model.value - 1
    input(newValue)
  }

</script>

<template>
  <div class="c-player-number-input">
    <button
      class="minus"
      :disabled="model <= 1"
      @click="minus"
    />
    <div class="count">
      <span class="value">{{ model }}</span>
      <SvgIcon
        icon="player"
        :width="18"
        :height="18"
      />
    </div>
    <button
      class="plus"
      :disabled="model >= props.max"
      @click="plus"
    />
  </div>
</template>

<style  scoped>

.c-player-number-input {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  button {
    position: relative;
    width: 2.5em;
    height: 2.5em;
    border: solid 1px rgb(26 44 54 / 20%);
    border-radius: 50%;
    opacity: 1;
    transition: opacity ease-out 0.15s;

    &::before,
    &::after {
      position: absolute;
      background-color: var(--color-secondary);
      content: "";
      opacity: 0.8;
    }

    &.minus {
      &::before {
        top: calc(50% - 1.5px);
        left: calc(50% - 7.5px);
        width: 15px;
        height: 3px;
      }
    }

    &.plus {
      &::before {
        top: calc(50% - 1.5px);
        left: calc(50% - 7.5px);
        width: 15px;
        height: 3px;
      }

      &::after {
        top: calc(50% - 7.5px);
        left: calc(50% - 1.5px);
        width: 3px;
        height: 15px;
      }
    }

    &[disabled] {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  .count {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0.5em 0.875em;
    border-radius: 4px;
    margin: 0 2em;
    background-color: var(--color-primary);

    .value {
      margin-right: 0.25em;
      color: white;
      font-family: Open-Sans, sans-serif;
      font-size: 1.25em;
      font-weight: 600;
    }

    .c-icon {
      color: white;
    }
  }
}
</style>
